import React from "react";
import "./Container.css";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
//Depends components
import { Header, NavBar, Footer } from "../";
import { TedErrorPopup } from "../../../core-ui/";
import { DeleteContent, ActionContent } from "../../../reusables";
import MemberDetailsModal from "../../../pages/deposit-members/small/MemberDetailsModal";
import EditMemberSyncModal from "../../../pages/deposit-members/small/EditMemberSyncModal";
import { TedModal } from "../../../core-ui";
//redux
import { useSelector } from "react-redux";
//constant
import { closeError, setOpenModal } from "../../../global-state/redux";

const Container = ({ pageName, children }) => {
  const configError = useSelector((store) => store.error);
  const { open, data, number, actionName, actionTitle } = useSelector(
    (store) => store.modal
  );
  const dispatch = useDispatch();

  console.log('Container modal state:', { open, actionName, actionTitle, number });

  return (
    <>
      <div className="container-app">
        <div className="navigation">
          <NavBar />
        </div>
        <div className="content-main">
          <Header pageName={pageName} />
          <main className="main-container-app">
            <div>{children}</div>
          </main>
          <Footer />
        </div>
      </div>
      <TedErrorPopup
        errorsConfig={configError} //  const errors = { messageError: msg, showError: err, typeError: typeErr,};
        fxClosePopup={() => dispatch(closeError())}
      />
      {open && actionName === "deleteContent" && <DeleteContent indexUrl={0} />}
      {open && actionName === "actionContent" && <ActionContent />}
      {open && actionName === "memberDetails" && (
        <TedModal 
          title={actionTitle}
          isOpen={open} 
          fxCloseAndOpen={() => dispatch(setOpenModal({ actionName: "", data: null, actionTitle: "", number: 0 }))}
          size="big"
        >
          <MemberDetailsModal data={data} />
        </TedModal>
      )}
      {open && actionName === "editMemberSync" && (
        <TedModal 
          title={actionTitle}
          isOpen={open} 
          fxCloseAndOpen={() => dispatch(setOpenModal({ actionName: "", data: null, actionTitle: "", number: 0 }))}
          size="big"
        >
          <EditMemberSyncModal data={data} />
        </TedModal>
      )}
    </>
  );
};

Container.propTypes = {
  pageName: PropTypes.any.isRequired,
};
export default Container;
